import { PlayIcon } from '@heroicons/react/24/solid';
import { Stack, StackProps, Typography, alpha, styled } from '@mui/material';

export const RootStyled = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

interface OptionStackStyledProps extends StackProps {
  clickable: boolean;
  selected: boolean;
}
export const OptionStackStyled = styled(Stack)<OptionStackStyledProps>(
  ({ theme, clickable, selected }) => ({
    background: selected
      ? alpha(theme.palette.primary.main, 0.2)
      : alpha(theme.palette.dark.dark_5, 0.6),
    borderRadius: theme.spacing(1),
    cursor: clickable ? 'pointer' : 'default',
  }),
);
export const VideoPlayerCardStyled = styled('video')(({ theme }) => ({
  width: '179px !important',
  height: '102px !important',
  borderRadius: theme.spacing(1),
  cursor: 'pointer',
  background: theme.palette.dark.dark_1,
}));
export const VideoPlayerCardPlaceholderStyled = styled('div')(({ theme }) => ({
  width: '179px !important',
  height: '102px !important',
  borderRadius: theme.spacing(1),
  border: `1px dashed  ${theme.palette.dark.dark_4}`,
  background: theme.palette.dark.dark_5,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const LineStyled = styled('div')(({ theme }) => ({
  background: theme.palette.dark.dark_4,
  height: '1px',
  width: '45%',
}));

export const DividerStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.dark.dark_4,
}));
export const VideoPlayerCardContainerStyled = styled('div')(({ theme }) => ({
  position: 'relative',
}));
export const PlayIconStyled = styled(PlayIcon)(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  cursor: 'pointer',
}));
